import { Injectable } from '@angular/core';
import { Router, CanActivate, UrlTree, ActivatedRouteSnapshot } from '@angular/router';
import { ADMIN_ROLES } from '@tripointe/tripointe-cms/types';

import { PermissionsService } from './permissions.service';

@Injectable({ providedIn: 'root' })
export class RoleGuard implements CanActivate {
  constructor(private router: Router, private permissionsService: PermissionsService) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const allowedRoles = route.data.allowedRoles || ADMIN_ROLES;
    const userRole = this.permissionsService.getUserRole();

    if (allowedRoles.includes(userRole)) {
      return true;
    } else {
      return this.router.parseUrl('/edit-profile');
    }
  }
}
